<template>
  <div class="row tgju-widgets-row dashboard-widgets-technical-list dash-full-height">
    <div class="col-12">
      <div class="tgju-widget light">
        <div class="list-widget widget-head-page list-row bold list-row-title">

          <div class="list-col l-title head-color">
            <span class="with-icon"><i class="uil uil-chart"></i>بازار ها</span>
          </div>

          <div class="list-col l-item pointer hover head-color">
            <span>
              <div class="fa fa-question-circle l-item-btn-pages"></div> راهنما
            </span>
          </div>
        </div>
        <div class="tgju-widget-content full-padding overflow-hidden">
          <MarketDynamic></MarketDynamic>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
    form i {
        margin-left: 5px;
    }
</style>

<script>
	// این ویو برای ماژول بازار بخش داینامیکش مورد استفاده قرار میگیرد
    import MarketDynamic from "@/components/Market/Dynamic";

    export default {
        name: "marketDynamicPage",
        components: {
          MarketDynamic,
        },
        data: function() {
            return {};
        },
        mounted() {},
    };
</script>